import { useMemo, useState } from "react";
import MediaCard from "@/components/feature/MediaCard";
import SectionHeading from "@/components/feature/SectionHeading";
import type { MediaItem, MediaType } from "@/types/media";

const TABS: { key: "all" | MediaType; label: string }[] = [
  { key: "all", label: "全部" },
  { key: "teleplay", label: "电视剧" },
  { key: "movie", label: "电影" },
  { key: "variety", label: "综艺" },
];

export default function HotSection({ items }: { items: MediaItem[] }) {
  const [tab, setTab] = useState<"all" | MediaType>("all");

  const list = useMemo(() => {
    const filtered = tab === "all" ? items : items.filter((item) => item.type === tab);
    return [...filtered].sort((a, b) => b.views - a.views).slice(0, 10);
  }, [items, tab]);

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-5">
        <SectionHeading title="热门推荐" subtitle="近期播放量居高不下的影视作品" moreTo="/category" moreLabel="全部分类" />
        <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200 shrink-0 self-start sm:self-auto">
          {TABS.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setTab(item.key)}
              className={`px-3 md:px-4 py-1.5 text-xs md:text-sm rounded-full whitespace-nowrap transition-colors cursor-pointer ${
                tab === item.key ? "bg-primary-500 text-background-50 font-medium" : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      {list.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {list.map((item) => (
            <MediaCard key={item.id} item={item} />
          ))}
        </div>
      ) : (
        <div className="rounded-lg border border-dashed border-background-300 py-14 text-center">
          <i className="ri-inbox-line text-3xl text-foreground-500" />
          <p className="mt-3 text-sm text-foreground-600">暂无相关影视内容</p>
        </div>
      )}
    </div>
  );
}